import { OverlayTrigger, Tooltip as BootstrapTooltip } from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorGray } from '../theme/palette';

const Tooltip = ({
  dir,
  text,
  children,
  ...other
}) => {
  // Processar quebras de linha no texto
  const processText = text => {
    if (!text) return ''; // Dividir o texto por quebras de linha e criar elementos JSX

    const lines = text.split('\n');
    return lines.map((line, index) => <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>);
  };

  const tooltip = <StyledTooltip dir={dir}>{processText(text)}</StyledTooltip>;
  return <OverlayTrigger overlay={tooltip} placement={dir} trigger={['hover', 'focus']} {...other}>
      {children}
    </OverlayTrigger>;
};

Tooltip.propTypes = {
  dir: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
export default Tooltip; // region STYLES

const StyledTooltip = styled(BootstrapTooltip)`
  z-index: 2000;

  .tooltip-inner {
    background-color: ${colorGray};
    font-size: 12px;
    line-height: 16px;
    padding: 8px 12px;
    white-space: pre-line;
    text-align: left;
    max-width: 300px;
  }

  &.bs-tooltip-end .tooltip-arrow::before,
  &.bs-tooltip-auto[x-placement^="end"] .tooltip-arrow::before {
    border-right-color: ${colorGray};
  }

  &.bs-tooltip-top .tooltip-arrow::before,
  &.bs-tooltip-auto[x-placement^="top"] .tooltip-arrow::before {
    border-top-color: ${colorGray};
  }

  &.bs-tooltip-bottom .tooltip-arrow::before,
  &.bs-tooltip-auto[x-placement^="bottom"] .tooltip-arrow::before {
    border-bottom-color: ${colorGray};
  }

  &.bs-tooltip-start .tooltip-arrow::before,
  &.bs-tooltip-auto[x-placement^="start"] .tooltip-arrow::before {
    border-left-color: ${colorGray};
  }
`; // endregion
